import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=ebdc0f60&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=ebdc0f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdc0f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebdc0f60')) {
      api.createRecord('ebdc0f60', component.options)
    } else {
      api.reload('ebdc0f60', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=ebdc0f60&scoped=true&", function () {
      api.rerender('ebdc0f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22EhOgjO6jB0j/JS/comp/DocBox.vue"
export default component.exports